"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlternativePractitionerSpecialities = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const react_1 = __importDefault(require("react"));
const user_specialities_image_svg_1 = __importDefault(require("../../assets/images/user-specialities-image.svg"));
const FormData_1 = require("../../context/FormData");
const constants_1 = require("../../context/FormData/Specialities/constants");
const Progress_1 = require("../../context/Progress");
const SurveyPageContentTemplate_1 = require("../../templates/SurveyPageContentTemplate/SurveyPageContentTemplate");
const SpecialityListWithTitle_1 = require("../SpecialityListWithTitle/SpecialityListWithTitle");
function AlternativePractitionerSpecialities({ nextRoute, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const [, dispatch] = (0, Progress_1.useProgress)();
    const [formDataState] = (0, FormData_1.useFormData)();
    react_1.default.useEffect(() => {
        dispatch((0, Progress_1.setCurrentPage)(2));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, []);
    react_1.default.useEffect(() => {
        /**
         * Can go next only if there is a selected speciality
         */
        dispatch((0, Progress_1.setCanGoNext)(formDataState.speciality !== undefined));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, [formDataState.speciality]);
    react_1.default.useEffect(() => {
        dispatch((0, Progress_1.setNextRoute)(nextRoute));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, [nextRoute]);
    return ((0, jsx_runtime_1.jsx)(SurveyPageContentTemplate_1.SurveyPageContentTemplate, { Image: user_specialities_image_svg_1.default, content: (0, jsx_runtime_1.jsx)(SpecialityListWithTitle_1.SpecialityListWithTitle, { title: t(i18n_1.Strings.userOnboarding.selectSpecialities.title
                .alternativePractitioner), specialities: constants_1.ALTERNATIVE_PRACTITIONER_SPECIALITIES }), "data-e2e": 'AlternativePractitionerSpecialities_SurveyPageContentTemplate' }));
}
exports.AlternativePractitionerSpecialities = AlternativePractitionerSpecialities;
